import React from "react";

const TableOverlay = ({ children, style }) => {
  return (
    <div className="TableOverlay" style={style}>
      <div className="TableOverlay_content">{children}</div>
    </div>
  );
};

export default TableOverlay;
